import React from 'react';
import { useSelector } from 'react-redux';
import { DartsSpinnerOverlay } from 'react-spinner-overlay';
import { Status } from '@api';
import { useTranslation } from 'react-i18next';

const Overlay = () => {
    const { t } = useTranslation();
    const { gameLaunchStatus } = useSelector(state => state.game);

    return (
        <DartsSpinnerOverlay
            loading={gameLaunchStatus === Status.LOADING}
            size={50}
            color='#fff'
            overlayColor='#EC7601'
            zIndex={2000}
            message={
                <div style={{ paddingTop: '10px', color: '#fff' }}>
                    {`${t("common.loading")}...`}
                </div>
            }
        />
    );
}

export default Overlay;